var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundedLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 431.06 431.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Neues_Verlaufsfeld_1);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Neues_Verlaufsfeld_1",
    x1: -6.32,
    y1: 343.62,
    x2: 437.38,
    y2: 87.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec6445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9b141"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Teckboard_Logo_Rounded") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_4",
    "data-name": "Ebene 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 431.06,
    height: 431.06,
    rx: 104.27,
    ry: 104.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M338.26,92.8v205a40.44,40.44,0,0,1-40.33,40.43h-.2a40.45,40.45,0,0,1-37.23-24.85A53.21,53.21,0,0,1,257.4,299c-1.58-19.47,5.16-46.82,27-83.43-92,91.81-182.57,121.34-191.18,122.71l-.37,0V146.69A53.89,53.89,0,0,1,146.69,92.8Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedLogo);
export default __webpack_public_path__ + "static/media/Rounded_Logo.88331f3b0981cd54e2b3ba8a9895f52a.svg";
export { ForwardRef as ReactComponent };